export default "__VITE_ASSET__B0NxGD1z__"